import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { BeatLoader } from "react-spinners";

function PaymentSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("processing"); // processing, success, error
  const [message, setMessage] = useState(t('payment-success-message'));

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        // استخراج المعاملات من الـ URL
        const params = new URLSearchParams(location.search);
        const orderId = params.get("order_id");

        if (!orderId) {
          setStatus("error");
          setMessage(t('payment-success-error-message1'));

          // الانتقال إلى صفحة الخطأ بعد 3 ثواني
          setTimeout(() => {
            navigate("/payment/error", {
              state: { 
                message: t('payment-success-error-message2')
              }
            });
          }, 3000);

          return;
        }

        // حفظ معلومات الطلب في localStorage
        localStorage.setItem("orderId", orderId);
        localStorage.setItem("transactionType", "order");
        
        // مسح البيانات المؤقتة
        localStorage.removeItem("promo");
        localStorage.removeItem("paymentMethod");
        localStorage.removeItem("process");
        localStorage.removeItem("timeNow");
        localStorage.removeItem("cartMessage");
        localStorage.removeItem("offer");
        localStorage.removeItem("orderDate");
        localStorage.removeItem("deliveryType");

        // تحديث الحالة
        setStatus("success");
        setMessage(t('payment-success-success-message1'));

        // الانتقال إلى صفحة النجاح بعد ثانيتين
        setTimeout(() => {
          navigate("/cart-process-4", { 
            state: { 
              message: t("payment-success-success-message2"),
              success: true,
              orderId: orderId,
              paymentMethod: "thawanipay"
            },
            replace: true // لمنع المستخدم من الرجوع لهذه الصفحة
          });
        }, 2000);

      } catch (error) {
        console.error("Error verifying payment:", error);
        setStatus("error");
        setMessage(t('payment-success-error-1'));
        
        // الانتقال إلى صفحة الخطأ بعد 3 ثواني
        setTimeout(() => {
          navigate("/payment/error", {
            state: { 
              message: t('payment-success-error-2')
            }
          });
        }, 3000);
      }
    };

    verifyPayment();

  }, [navigate, location]);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      flexDirection: "column",
      backgroundColor: "#f8f9fa",
      padding: "20px"
    }}>
      <div style={{
        backgroundColor: "white",
        padding: "40px",
        borderRadius: "12px",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        textAlign: "center",
        maxWidth: "500px",
        width: "100%"
      }}>
        {status === "processing" && (
          <>
            <BeatLoader color="#ffc010" size={20} />
            <h2 style={{ marginTop: "20px", color: "#333" }}>{message}</h2>
            <p style={{ color: "#666", marginTop: "10px" }}>
              {t('payment-success-loading')}
            </p>
          </>
        )}
        
        {status === "success" && (
          <>
            <div style={{
              width: "80px",
              height: "80px",
              backgroundColor: "#28a745",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px"
            }}>
              <span style={{ fontSize: "40px", color: "white" }}>✓</span>
            </div>
            <h2 style={{ color: "#28a745", marginBottom: "10px" }}>{message}</h2>
            <p style={{ color: "#666" }}>
              {t("payment-success-success-des")}
            </p>
          </>
        )}
        
        {status === "error" && (
          <>
            <div style={{
              width: "80px",
              height: "80px",
              backgroundColor: "#dc3545",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px"
            }}>
              <span style={{ fontSize: "40px", color: "white" }}>✕</span>
            </div>
            <h2 style={{ color: "#dc3545", marginBottom: "10px" }}>{message}</h2>
            <p style={{ color: "#666" }}>
              {t('payment-success-error-des')}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default PaymentSuccess;